import getBasePath from '@/common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'extensao');

const extensaoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?nome={nome}&indAtivo=true&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}{&idsNiveisExtensao*}{&idsDependencias*}` },
  listarExtensoes: { method: 'GET', url: `${basePath}?nome={nome}&colunaOrdenacao=nom_extensao&idNivelExtensao={idNivelExtensao}{&idsNotIn*}{&idsExternosObrigatorios*}{&idsNiveisExtensao*}{&idsDependencias*}` },
  listarPorUsuario: { method: 'GET', url: `${basePath}?tamanhoPagina=10&numeroPagina=1&nome={nome}&indAtivo=true&idNivelExtensao={idNivelExtensao}&usuarioLogado=true&colunaOrdenacao=nom_extensao` },
  obter: { method: 'GET', url: `${basePath}/{id}` },
  atualizarAutoRelacionamento: { method: 'PUT', url: `${basePath}/auto-relacionamento` },
  gravarAutoRelacionamento: { method: 'POST', url: `${basePath}/auto-relacionamento` },
  listarNiveisExtensao: { method: 'GET', url: `${basePath}/nivel-extensao?{&idsNiveisExtensao*}` },
  listarDetalhado: { method: 'GET', url: `${basePath}/detalhado?tamanhoPagina={size}&numeroPagina={page}{&idsNiveisExtensao*}` },
  listarNiveisExtensaoEntidade: { method: 'GET', url: `${basePath}/nivel-extensao/{entidade}` },
  selecao: { method: 'GET', url: `${basePath}/selecao?{&idsDependencias*}` },
};

export default (resource) => resource(`${basePath}`, {}, extensaoActions);
